<div class="text-center m-t-xl" *ngIf="!(user$ | async)?.lastname">
	<h3 class="section-title">Could not load this staff user</h3>
	<button class="btn btn-default" (click)="getUser()">Try Again</button>
</div>

<div class="container" *ngIf="(user$ | async)?.lastname">
	<div class="m-b-lg user-detail-headers" layout="row" layout-align="none center">
		<h2 class="page-title m-0">{{(user$ | async)?.firstname}} {{(user$ | async)?.lastname}} <span class="mr-space color-gray md"> ID # {{user.id}}</span></h2>
		<span class="status-container">
			<mat-card class="result">
				<mat-card-content>
					<label style="margin-left: 40px; padding-top: 12px; padding-right: 5px;">Status</label>
					<ng-container [formGroup]="userForm" *ngIf="user$ | async as user">
						<mat-slide-toggle formControlName="active" (ngModelChange)="user.active = $event">
							{{ user.active ? 'Active' : 'Inactive' }}
						</mat-slide-toggle>
					</ng-container>
				</mat-card-content>
			</mat-card>
		</span>
	</div>
	<div class="div">
		<form [formGroup]="userForm" (ngSubmit)="updateUserDetails()">
			<div class="form-group">
				<div class="row">
					<div class="col-xs-6">
						<label for="title">Title</label>
						<select formControlName="title" class="form-control" id="title" maxlength="35">
							<option *ngFor="let userTitle of userTitles">{{ userTitle }}</option>
						</select>
						<div *ngIf="informationButtonHovered && userForm.get('title')?.hasError('required')" class="error-message">Title is required</div>
					</div>
					<div class="col-xs-6">
						<label for="credentials">Credentials</label>
						<input formControlName="credentials" class="form-control" type="text" id="credentials" maxlength="35">
					</div>
				</div>
				<div class="row">
					<div class="col-xs-6">
						<label for="firstname">First Name</label>
						<input formControlName="firstname" class="form-control" type="text" id="firstname" maxlength="35">
						<div *ngIf="informationButtonHovered && userForm.get('firstname')?.hasError('required')" class="error-message">First Name is required</div>
					</div>
					<div class="col-xs-6">
						<label for="lastname">Last Name</label>
						<input formControlName="lastname" class="form-control" type="text" id="lastname" maxlength="35">
						<div *ngIf="informationButtonHovered && userForm.get('lastname')?.hasError('required')" class="error-message">Last Name is required</div>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-6">
						<label for="mfa_bypass">MFA Options
							<select class="form-control" formControlName="mfa_bypass" id="mfa_bypass">
								<option [value]="null" hidden disabled selected>Select bypass status</option>
								@for (state of  MFA_STATES(); track state.id) {
									<option [value]="state.value">{{ state.label }}</option>
								}
							</select>
						</label>
					</div>
				</div>
			</div>
			<div class="form-group" (mouseenter)="informationButtonHovered = true" (mouseleave)="informationButtonHovered = false">
				<button class="btn btn-success" type="submit" [disabled]="userForm.invalid">
					Update User Information
				</button>
			</div>
		</form>
	</div>
	<h4 style="margin-top: 42px; margin-bottom: 20px;">Licenses</h4>
	<div *ngIf="!user.licenses?.length" layout="row" layout-align="center center">
		<strong class="color-gray-md">NO LICENSES REGISTERED</strong>
	</div>
	<div *ngIf="user.licenses?.length">
		<table mat-table [dataSource]="dataSource" class="mat-elevation-z8 black">

			<!-- ID Column -->
			<ng-container matColumnDef="id">
				<th mat-header-cell *matHeaderCellDef> ID </th>
				<td mat-cell *matCellDef="let element"> {{element.id}} </td>
			</ng-container>

			<!-- State Code Column -->
			<ng-container matColumnDef="state_code">
				<th mat-header-cell *matHeaderCellDef> State Code </th>
				<td mat-cell *matCellDef="let element"> {{element.state_code}} </td>
			</ng-container>

			<!-- License Number Column -->
			<ng-container matColumnDef="license_number">
				<th mat-header-cell *matHeaderCellDef> License Number </th>
				<td mat-cell *matCellDef="let element"> {{element.license_number}} </td>
			</ng-container>

			<!-- Buttons Column -->
			<ng-container matColumnDef="buttons">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let element"> <button class="btn btn-default" style="float: right;" (click)="removeLicense(element.state_code)">Remove</button> </td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
		</table>
	</div>
	<h4 style="margin-top: 30px; margin-bottom: 20px;">Add new</h4>
	<form [formGroup]="licenseForm" (ngSubmit)="addLicense()">
		<div class="tbody">
			<div class="tr" style="line-height: 0.5;">
				<div class="td">
					<label for="selectedState">State</label>
				</div>
				<div class="td">
					<div class="select-box" style="width: 160px; display: inline-block;">
						<select class="form-control" formControlName="selectedState" id="selectedState">
							<option *ngFor="let state of states$ | async" [value]="state.code">{{ state.state }}</option>
						</select>
					</div>
					<div *ngIf="licenseButtonHovered && licenseForm.get('selectedState')?.hasError('required')" class="error-message">State is required</div>
				</div>
				<div class="td">
					<label for="licenseNumber">License Number</label>
				</div>
				<div class="td">
					<input class="form-control" type="text" formControlName="licenseNumber" id="licenseNumber" style="font-weight: bold;">
					<div *ngIf="licenseButtonHovered && licenseForm.get('licenseNumber')?.hasError('required')" class="error-message">License number is required</div>
				</div>
				<div class="td" (mouseenter)="licenseButtonHovered = true" (mouseleave)="licenseButtonHovered = false">
					<button class="btn btn-success" type="submit" [disabled]="licenseForm.invalid">Add/Update License</button>
				</div>
			</div>
		</div>
	</form>
	<ng-container class="container"*ngIf="isUserValidForSignatureUpload$ | async">
		<prescriber-files [userId]="userId()"></prescriber-files>
	</ng-container>
	<ng-container class="container">
		<h4 style="margin-top: 30px; margin-bottom: 20px;">Roles</h4>
		<form [formGroup]="rolesForm" (ngSubmit)="updateUserRoles()">
			<div class="form-group m-b-md user-block" style="column-count: 2; column-gap: 0px; width: 550px;">
				<label class="block" *ngFor="let role of roles$ | async">
					<input type="checkbox" [value]="role.name" [checked]="role.checked" (change)="updateRoles($event)"> {{ role.name }}
				</label>
			</div>
			<label style="margin-top: 10px;">Audit notes</label>
			<input class="form-control notes-form" style="width: 50%; padding: 15px 0px 50px 10px; margin: 15px 0px" type="text" id="notes" formControlName="note">
			<div *ngIf="rolesButtonHovered && rolesForm.get('note')?.hasError('required')" class="error-message">Note is required.</div>
			<div (mouseenter)="rolesButtonHovered = true" (mouseleave)="rolesButtonHovered = false" style="overflow: auto;">
				<button type="submit" [disabled]="rolesForm.invalid" class="btn btn-default" style="float: left; background-color: #77C660FF; color: white; border: none; margin-top: 10px;" (mouseenter)="rolesButtonHovered = true">Update user roles</button>
			</div>
		</form>
	</ng-container>
</div>

